import React, { useEffect, useState } from 'react';
import { RootState } from 'src/store/reducers/state';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalyticsActions } from 'src/store/analytics/actions';
import { useParams, Link } from 'react-router-dom';
import { defaultDateFormatter } from 'src/components/utilities/utils';
import Pagination from 'src/components/common/pagination';
import Loader from 'src/components/loader';
const SinglePollQuestion: React.FC = () => {
  const dispatch = useDispatch();
  const analyticsAction = useAnalyticsActions(dispatch);
  const { id } = useParams<string>();
  const { singlePollQuestion, paginationMeta, isSinglePollQuestionLoading } = useSelector(
    (state: RootState) => {
      return {
        singlePollQuestion: state.analytics.singlePollQuestion,
        paginationMeta: state.analytics.paginationMeta,
        isSinglePollQuestionLoading: state.analytics.isSinglePollQuestionLoading
      };
    }
  );

  useEffect(() => {
    id && analyticsAction.getSinglePollQuestionRequest({ id, pageNumber: 1, pageSize: 20 });
  }, []);

  const handlePageChange = (pageNumber: number) => {
    id && analyticsAction.getSinglePollQuestionRequest({ id, pageNumber, pageSize: 20 });
  };
  return (
    <>
      <div className="dashboard">
        <Link to={`/analytic/polls`}>
          <i className="fas fa-arrow-left mt-2 mb-2"></i>
          <span className="ml-2">Go Back</span>
        </Link>
        <div>
          <div className="mt-2">
            <div className=" py-4 border-b border-gray-100 md:flex justify-between items-center">
              <h2 className="font-semibold ">Poll Questions</h2>
            </div>

            <div className="flex flex-col justify-center h-full">
              <div className="w-full mx-auto bg-white shadow-card rounded-lg relative">
                <div className="p-3">
                  <div className="overflow-x-auto">
                    <table className="table-auto w-full border">
                      <thead className="text-xs font-semibold uppercase bg-gray-50">
                        <tr>
                          <th className="p-2">
                            <div className="font-semibold text-left">Question Name</div>
                          </th>
                          <th className="p-2">
                            <div className="font-semibold text-left">Quiz Name</div>
                          </th>

                          <th className="p-2">
                            <div className="font-semibold text-left">Created Date</div>
                          </th>
                          <th className="p-2">
                            <div className="font-semibold text-left">Created BY</div>
                          </th>
                          <th className="p-2">
                            <div className="font-semibold text-left">Last Activity Date</div>
                          </th>
                          <th className="p-2">
                            <div className="font-semibold text-left">Correct Answers</div>
                          </th>
                          <th className="p-2">
                            <div className="font-semibold text-left">Incorrect Answers</div>
                          </th>
                          <th className="p-2">
                            <div className="font-semibold text-left">Highest Incorrect Answers</div>
                          </th>
                          <th className="p-2">
                            <div className="font-semibold text-left">Top Incorrect Answers</div>
                          </th>
                          <th className="p-2">
                            <div className="font-semibold text-left">Median</div>
                          </th>
                          <th className="p-2">
                            <div className="font-semibold text-left">StandardDeviation</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-sm divide-y divide-gray-100">
                        {isSinglePollQuestionLoading ? (
                          <tr>
                            <td>
                              <Loader />
                            </td>
                          </tr>
                        ) : (
                          <>
                            {singlePollQuestion && singlePollQuestion.length ? (
                              singlePollQuestion.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="p-2">
                                      <div className="text-left">{item.quizName}</div>
                                    </td>
                                    <td className="p-2">
                                      <div className="text-left">{item.questionName}</div>
                                    </td>

                                    <td className="p-2">
                                      <div className="text-left">
                                        {item.createdDate ? defaultDateFormatter(item.createdDate) : ''}
                                      </div>
                                    </td>
                                    <td className="p-2">
                                      <div className="text-left">{item.createdBy}</div>
                                    </td>
                                    <td className="p-2">
                                      <div className="text-left">
                                        {item.lastActivityDate ? defaultDateFormatter(item.lastActivityDate) : ''}
                                      </div>
                                    </td>
                                    <td className="p-2">
                                      <div className="text-left">{item.correctAnswers}</div>
                                    </td>
                                    <td className="p-2">
                                      <div className="text-left">{item.incorrectAnswers}</div>
                                    </td>
                                    <td className="p-2">
                                      <div className="text-left">
                                        {item.highestIncorrectAnswers}
                                      </div>
                                    </td>
                                    <td className="p-2">
                                      <div className="text-left">
                                        {item.topIncorrectAnswersRate}
                                      </div>
                                    </td>
                                    <td className="p-2">
                                      <div className="text-left">{item.median}</div>
                                    </td>
                                    <td className="p-2">
                                      <div className="text-left">{item.standardDeviation}</div>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td className="text-center py-2" colSpan={5}>
                                  No Data Found
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>
                    {!!paginationMeta && !!Object.keys(paginationMeta).length && (
                      <Pagination
                        currentPage={paginationMeta.pageNumber}
                        totalCount={paginationMeta.totalCount}
                        pageSize={paginationMeta.pageSize}
                        onPageChange={(page: any) => handlePageChange(page)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SinglePollQuestion;
